import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Re-export utility functions from backend
export { formatDate, formatDateTime, formatRaceTime, parseRaceTime } from "@/backend/lib/utils";
